import React from 'react';
import { motion } from 'framer-motion';
import { Check, ShieldCheck, ArrowRight } from 'lucide-react';
export function PriceBlock() {
  return <section id="price-block" className="py-24 bg-[#1a3c2a] relative overflow-hidden" data-id="element-119">
      {/* Background decoration */}
      <div className="absolute top-0 left-0 w-full h-full opacity-10 pointer-events-none" data-id="element-120">
        <div className="absolute top-0 left-0 w-64 h-64 bg-[#c9a84c] rounded-full filter blur-3xl opacity-30 transform -translate-x-1/2 -translate-y-1/2" data-id="element-121" />
        <div className="absolute bottom-0 right-0 w-96 h-96 bg-[#c9a84c] rounded-full filter blur-3xl opacity-30 transform translate-x-1/2 translate-y-1/2" data-id="element-122" />
      </div>

      <div className="max-w-4xl mx-auto px-4 sm:px-6 relative z-10" data-id="element-123">
        <motion.div initial={{
        opacity: 0,
        scale: 0.95
      }} whileInView={{
        opacity: 1,
        scale: 1
      }} viewport={{
        once: true
      }} className="bg-[#faf8f0] rounded-3xl shadow-2xl overflow-hidden" data-id="element-124">
          <div className="bg-[#c9a84c] py-4 text-center" data-id="element-125">
            <span className="text-[#1a3c2a] font-bold tracking-wider uppercase text-sm" data-id="element-126">
              Limited Time Offer
            </span>
          </div>

          <div className="p-8 md:p-12 text-center" data-id="element-127">
            <h2 className="text-3xl md:text-4xl font-bold text-[#1a3c2a] mb-4" data-id="element-128">
              Get Everything for Just $6.39
            </h2>
            <p className="text-[#5c4a32] mb-8" data-id="element-129">
              Less than 1 doctor visit. Digital download. No shipping. Instant
              access.
            </p>

            <div className="flex flex-col md:flex-row justify-center items-center gap-4 mb-8 text-5xl font-bold text-[#1a3c2a]" data-id="element-130">
              <span className="text-gray-400 line-through text-3xl decoration-red-500 decoration-2" data-id="element-131">
                $27
              </span>
              <span data-id="element-132">$6.39</span>
            </div>

            <div className="max-w-md mx-auto text-left space-y-3 mb-10" data-id="element-133">
              {['Natural Remedies Encyclopedia (PDF)', 'Symptom Matrix Grid', 'Dosage Calculator', '7-Day Gut Cleanse Protocol', '30-Day Energy Challenge'].map((item, i) => <div key={i} className="flex items-center gap-3" data-id="element-134">
                  <div className="bg-[#1a3c2a] rounded-full p-1" data-id="element-135">
                    <Check className="w-3 h-3 text-white" data-id="element-136" />
                  </div>
                  <span className="text-[#1a3c2a] font-medium" data-id="element-137">{item}</span>
                </div>)}
            </div>

            <a href="https://guiastoolkit.com/cart/45959772340412:1" target="_blank" rel="noopener noreferrer" className="w-full md:w-auto bg-[#1a3c2a] text-white px-10 py-5 rounded-xl text-xl font-bold shadow-xl hover:bg-[#2d5a3d] hover:scale-[1.02] transition-all duration-300 flex items-center justify-center gap-3 mx-auto group" data-id="element-138">
              Get Your Symptom Matrix Now
              <ArrowRight className="w-6 h-6 group-hover:translate-x-1 transition-transform" data-id="element-139" />
            </a>

            <div className="mt-8 flex items-center justify-center gap-2 text-[#5c4a32] text-sm" data-id="element-140">
              <ShieldCheck className="w-5 h-5 text-[#c9a84c]" data-id="element-141" />
              <span data-id="element-142">30-Day Money-Back Guarantee</span>
            </div>
          </div>
        </motion.div>
      </div>
    </section>;
}